import React from 'react';
import { openFranchiseFinmodelForm } from './franchiseConstants';

export function HeroSection() {
  return (
    <section id="s-hero" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-hero" data-reveal>
          <img className="franchise-hero__fish" src="/assets/media/franchise/hero-section/fish.svg" alt="Рыбки" />
          <img className="franchise-hero__logo" src="/assets/media/franchise/hero-section/logo.svg" alt="Лого" />
          <div className="franchise-hero__title">
            <span>Открой</span>
            <span>прибыльный</span>
            <span>бизнес</span>
            <div className="franchise-hero__last-line">
              <span>в своем городе</span>
              <img src="/assets/media/franchise/hero-section/location.svg" alt="Location" />
            </div>
          </div>
          <div className="franchise-hero__text">заработай от 350 000 рублей в месяц</div>
          <button className="franchise-hero__button" type="button" onClick={openFranchiseFinmodelForm()}>
            <span>Получить</span>
            <span>финансовую модель</span>
          </button>
          <img className="franchise-hero__fish-2" src="/assets/media/franchise/hero-section/fish-2.svg" alt="Рыбки" />
          <div className="franchise-hero__wrapper">
            <img className="franchise-hero__map" src="/assets/media/franchise/hero-section/map.svg" alt="Карта" />
          </div>
          <img className="franchise-hero__marks" src="/assets/media/franchise/hero-section/group.svg" alt="Метки" />
        </div>
      </div>
    </section>
  );
}
